import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueUeditorWrap from '@/components/vue-ueditor-wrap.vue';
export default {
  name: 'Question16',
  props: {
    showType: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      zmArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  components: {
    'vue-ueditor-wrap': VueUeditorWrap
  },
  methods: {
    /**
     * 点击添加 根据进度时间的背景图片
     */
    clickAddOne: function clickAddOne() {
      console.log("this.value:", this.value);

      if (!this.value.eqOtherInfo_16) {
        this.$set(this.value, "eqOtherInfo_16", []);
      }

      this.value.eqOtherInfo_16.push({});
    },

    /**
     * 删除背景图片
     */
    clickDeleteOne: function clickDeleteOne(index) {
      this.value.eqOtherInfo_16.splice(index, 1);
    }
  }
};